import { useEffect, useState } from 'react';
import type {
  ColumnFiltersState,
  PaginationState,
  SortingState,
} from '@tanstack/react-table';
import { useLoadViewState } from '../cachedViewState/useLoadViewState';
import { saveViewState } from '../cachedViewState/viewState';
import { DEFAULT_TABLE_PAGE_SIZE } from '../tanstacktable';

export const usePersistentTableState = <StorageKey extends string = string>(
  storageKey: StorageKey,
  defaults?: {
    filters?: ColumnFiltersState;
    sort?: SortingState;
    pagination?: PaginationState;
  },
) => {
  const { state: initial } = useLoadViewState(storageKey, {
    filters: defaults?.filters ?? [],
    sort: defaults?.sort ?? [],
    pagination: defaults?.pagination ?? {
      pageIndex: 0,
      pageSize: DEFAULT_TABLE_PAGE_SIZE,
    },
  });

  const [filters, setFilters] = useState<ColumnFiltersState>(initial.filters);
  const [sort, setSort] = useState<SortingState>(initial.sort);
  const [pagination, setPagination] = useState<PaginationState>(
    initial.pagination,
  );

  useEffect(() => {
    saveViewState(storageKey, { filters, sort, pagination });
  }, [storageKey, filters, sort, pagination]);

  return {
    filters,
    setFilters,
    sort,
    setSort,
    pagination,
    setPagination,
  };
};
